export function invoiceDocumentListTitle(doc: {
  source?: string | null;
  filename?: string | null;
  invoice_number?: string | null;
}): string {
  if (doc.source === "sage_import") return String(doc.invoice_number ?? "").trim();
  const filename = String(doc.filename ?? "").trim();
  if (filename) return filename;
  return String(doc.invoice_number ?? "").trim();
}

/** Nummer, Titel und Dateiname. Die Sage-Nummer trifft auch ohne Dateiname. */
export function invoiceDocumentListMatches(
  doc: {
    source?: string | null;
    filename?: string | null;
    invoice_number?: string | null;
  },
  query: string,
): boolean {
  const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const hay = [invoiceDocumentListTitle(doc), doc.invoice_number, doc.filename]
    .map((part) => String(part ?? "").trim().toLowerCase())
    .filter(Boolean)
    .join(" ");
  return tokens.every((token) => hay.includes(token));
}
